import React, { useState, useEffect } from 'react';
import KassaTransactionModal from './KassaTransactionModal';
import KassaService from '../../services/KassaService';
import TransportService from '../../services/TransportService';
import KassaKirimService from '../../services/KassaKirimService';
import { toast } from 'react-toastify';

const KassaIncomeModal = ({ show, onHide, editing = false, initialData = {}, refreshData = () => {} }) => {
  const [kassas, setKassas] = useState([]);
  const [transports, setTransports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [kassaRes, transportRes] = await Promise.all([
        KassaService.getKassaList(),
        TransportService.getTransportList()
      ]);
      setKassas(kassaRes.data || []);
      setTransports(transportRes.data || []);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError('Ma\'lumotlarni yuklashda xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      
      if (editing && initialData.id) {
        await KassaKirimService.updateKassaKirim(data, initialData.id);
        toast.success('Kassa kirimi muvaffaqiyatli yangilandi');
        refreshData();
      } else {
        await KassaKirimService.createKassaKirim(data);
        toast.success('Kassa kirimi muvaffaqiyatli qo\'shildi');
      }
      
      onHide(true); // true means success
    } catch (err) {
      console.error('Error saving kassa kirim:', err);
      setError(err.message || 'Xatolik yuz berdi. Iltimos qaytadan urinib ko\'ring.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <KassaTransactionModal
      show={show}
      onHide={() => onHide(false)}
      title={editing ? 'Kassa Kirimini Tahrirlash' : 'Yangi Kassa Kirimi'}
      kassas={kassas}
      transports={transports}
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      initialData={initialData}
      isExpense={false}
      editing={editing}
    />
  );
};

export default KassaIncomeModal;
